import axios from "axios";
import { API_HOST } from "@/core/variables";
import { SelectorCreate, SelectorUpdate } from "@/model";

class SelectorRepository {
    find = async (agentId: number, page: number = 0, size: number = 15, keyword?: string, sortKey?: string, sortOrder?: string) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}/selectors`, {
            params: {
                page: page,
                size: size,
                sentence: keyword,
                sort_key: sortKey,
                order: sortOrder
            }
        });
    };

    create = async (agentId: number, form: SelectorCreate) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/selectors`, {
                agent_id: agentId,
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    update = async (agentId: number, selector_id: string, form: SelectorUpdate) => {
        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/selectors/${selector_id}`, {
                agent_id: agentId,
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    deleteMany = async (agentId: number, ids?: string[], keyword?: string) => {
        const params = new URLSearchParams();
        ids?.forEach((id) => params.append("ids", `${id}`));
        if (keyword)
            params.append("keyword", keyword);

        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/selectors`, {
                params: params
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));;
    };

    upload = async (agentId: number, selector_file: File, isCleanImport?: boolean) => {
        let form = new FormData();
        const is_clean_import = isCleanImport ? '1' : '0';
        form.append("is_clean_import", is_clean_import);
        form.append("file", selector_file);

        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/selectors/import`, form)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    export = async (agentId: number, params?: {ids?: string[], keyword?: string}) => {
        const urlParams = new URLSearchParams();
        params?.ids?.forEach((id) => urlParams.append("ids", `${id}`));
        if (params?.keyword)
            urlParams.append("keyword", params?.keyword);

        window.open(`${API_HOST}/v1/agents/${agentId}/selectors/export?${urlParams}`);
    };
}

const selectorRepository = new SelectorRepository();
export default selectorRepository;